import { saveConfiguration, verifyConfiguration , getConfiguration } from '@src/api/serviceIntegrations';
import { useMutation, useQueryClient , useQuery } from '@tanstack/react-query';
import { message } from 'antd';
import { useResetPanelAtoms } from '../hooks';
import { ServiceIntegration } from '../types';

export const useFetchIntegration = ({ configId = null }) => {
  const {
    data = {},
    isLoading = false,
    isError,
    refetch,
    isFetched,
    isFetching,
  } = useQuery(
    ['service-integration', configId],
    (): Promise<ServiceIntegration> =>
      getConfiguration({ configId }).then(({ data }) => data?.data),
    {
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!configId,
    },
  );

  return { data, isLoading, isError, refetch, isFetched, isFetching };
};

export const useVerifyIntegration = (setIsVerified) => {
  return useMutation(
    (payload: any) => {
      return verifyConfiguration(payload);
    },
    {
      onSuccess: () => {
        setIsVerified(true);
        message.success('Verified successfully!');
      },
      onError: (e) => {
        setIsVerified(false);
        message.error(
          'There was an error verifying this integration. Please check the details and try again later.',
        );
      },
    },
  );
};

export const useSaveIntegration = () => {
  const queryClient = useQueryClient();
  const resetAtoms = useResetPanelAtoms();

  return useMutation(
    (payload: any) => {
      return saveConfiguration(payload);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['service-integrations-list']);
        resetAtoms.reset();
      },
      onError: () => {
        message.error('There was an error saving. Please try again later.');
      },
    },
  );
};
